import { createSelector } from '@reduxjs/toolkit'

const featureFlags = ({ featureFlags }) => featureFlags || {}

export const featureFlagsSelector = createSelector(
  featureFlags,
  flags => flags
)

export const studioTablesEnabledSelector = createSelector(
  featureFlags,
  flags => Boolean(flags.studio_tables)
)
